import { GetServerSidePropsContext, NextPage } from 'next/types';

import SubscriptionWrapper from 'src/components/subscriptions/SubscriptionWrapper';
import SubscriptionWrapperNew from 'src/components/subscriptions/SubscriptionWrapperNew';
import { BannerAPIContentType } from 'src/services/responseTypes/BannerApiResponse';
import { Data } from 'src/services/responseTypes/displayPlansResponse';
import { SubscriptionResponse } from 'src/types/subscription';
import {
  FeatureFlagConstants,
  REMOTE_CONFIG
} from 'src/utils/constants/utilConstants';
import { isFeatureEnabled } from 'src/utils/RemoteConfig';
import {
  getNewSubscriptionProps,
  getOldSubscriptionProps
} from 'src/utils/SubscriptionHelper/serverSideProps';

import SimpleStore from '../../store/SimpleStore';

type Props = {
  bannerImages: BannerAPIContentType[];
  firstBannerImageUrl: string;
  plansData: Data;
  plansDataNew: SubscriptionResponse;
  version: boolean;
};

const Subscription: NextPage<Props> = (props) => {
  const showOld = props.version;
  if (showOld) return <SubscriptionWrapper {...props} />;
  return <SubscriptionWrapperNew {...props} />;
};
export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const remoteConfig = SimpleStore.get(REMOTE_CONFIG);
  const showOld = !isFeatureEnabled(
    remoteConfig,
    FeatureFlagConstants.FEATURE_NEW_SUBSCRIPTION_UI
  );
  const serverProps = showOld
    ? await getOldSubscriptionProps(context)
    : await getNewSubscriptionProps(context);
  return {
    props: {
      ...serverProps.props,
      version: showOld
    }
  };
};

export default Subscription;
